export default "__VITE_ASSET__Ci002JW___"